export default "__VITE_ASSET__7VliF1ln__"